import REST from "./rest";

class AuthAPI extends REST {
    constructor() {
        super();
        this.baseURL = `${window.config.baseurl}wp-json/jwt-auth/v1`;
    }

    /**
     * Get Token
     */
    getToken(username = '', password = '') {
        return this._request('post', 'token', null, { username, password });
    }

    /**
     * Validate Token
     */
    validateToken() {
        return this._request('post', 'token/validate');
    }
}

const api = new AuthAPI();

export default api;



// WEBPACK FOOTER //
// ./src/api/auth.js